// extracted by mini-css-extract-plugin
export default {"main-head":"MainHead_main-head__7oNKj","widthAnimation":"MainHead_widthAnimation__aGNrR"};